import React from 'react';
import {
  SaveButton,
  fetchEnd,
  fetchStart,
  showNotification,
  refreshView
} from 'react-admin';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';

import AddExistingInvestorForm from './AddExistingInvestorForm';
import DialogTitleWithCloseButton from '../../../core/components/DialogTitleWithCloseButton';
import InvestorApi from '../../../core/apis/InvestorApi';
import { createPluralizedMessage } from '../../../core/utils/index';
import messages from '../../../core/i18n/englishLanguageMessages';
import { getIcError } from '../../../core/providers/utils';

class AddExistingInvestorDialog extends React.Component {
  investorFormProps;

  state = {
    submitting: false
  };

  setInvestorFormProps = props => {
    this.investorFormProps = props;
  };

  handleSaveClick = event => {
    // Trigger a submit of our custom quick create/update form
    // This is needed because our modal action buttons are oustide the form
    this.investorFormProps.form.submit(event);
  };

  handleClose = () => {
    const { handleDialogToggle } = this.props;
    const { submitting } = this.state;
    if (submitting) return;
    this.investorFormProps.form.reset();
    handleDialogToggle();
  };

  handleSubmit = values => {
    const {
      organizationId,
      fetchStart,
      fetchEnd,
      showNotification,
      handleDialogToggle,
      investors,
      refreshView
    } = this.props;

    this.setState({ submitting: true });

    // Prepare the list of investors to update and set specific family as a parent
    const investorsToBeUpdated = [];
    values.investors.forEach(investor => {
      let visibleInvestors = investors.data;
      let initialInvestor = visibleInvestors[investor];
      investorsToBeUpdated.push({
        ...initialInvestor,
        organizationId: organizationId
      });
    });

    // Dispatch an action letting react-admin know a API call is ongoing
    fetchStart();

    // As we want to know when the new investor has been created/updated in order to close the modal, we use the
    // dataProvider directly to update, and async api call to update many
    const resultOperation = InvestorApi.update(investorsToBeUpdated);

    resultOperation
      .then(() => {
        refreshView();
        handleDialogToggle();
        showNotification(
          createPluralizedMessage(
            messages.ra.notification.updated,
            investorsToBeUpdated.length
          )
        );
      })
      .catch(error => {
        showNotification('ra.notification.server', 'error', {
          messageArgs: { message: getIcError(error) }
        });
      })
      .finally(() => {
        // Dispatch an action letting react-admin know a API call has ended
        this.investorFormProps.form.reset();
        fetchEnd();
        this.setState({ submitting: false });
      });
  };

  render() {
    const { showDialog, refreshView, ...rest } = this.props;
    const { submitting } = this.state;

    return (
      <Dialog
        fullWidth
        open={showDialog}
        aria-label={`Create investor`}
        maxWidth="sm"
        onClose={(event, reason) => {
          if (reason === 'backdropClick') return null;
          this.handleClose();
        }}
      >
        <DialogTitleWithCloseButton onClose={this.handleClose}>
          {'Add Existing Investor to Family'}
        </DialogTitleWithCloseButton>
        <DialogContent>
          <AddExistingInvestorForm
            {...rest}
            setInvestorFormProps={this.setInvestorFormProps}
            handleSubmit={this.handleSubmit}
          />
        </DialogContent>
        <DialogActions>
          <SaveButton
            saving={submitting}
            handleSubmitWithRedirect={this.handleSaveClick}
            label={'Add'}
            icon={<></>}
          />
          <Button
            onClick={this.handleClose}
            variant="outlined"
            color="primary"
            disabled={submitting}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = {
  fetchEnd,
  fetchStart,
  showNotification,
  refreshView
};

export default connect(null, mapDispatchToProps)(AddExistingInvestorDialog);
